import { useRef, useState } from "react";
import { Car, Camera } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, TOKEN_KEY } from "@/lib/api";
import { cn } from "@/lib/utils";

export const vehicleImageUrl = (v) => (v?.image_path ? `${process.env.REACT_APP_BACKEND_URL}/api/vehicles/${v.id}/image?auth=${localStorage.getItem(TOKEN_KEY)}&v=${encodeURIComponent(v.updated_at || "")}` : null);

export function VehicleImage({ vehicle, className, editable, onChanged }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const url = vehicleImageUrl(vehicle);
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try { await api.post(`/vehicles/${vehicle.id}/image`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Profile image updated"); onChanged?.(); } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className={cn("relative shrink-0 overflow-hidden rounded-xl bg-secondary", className)} data-testid={`vehicle-image-${vehicle.registration_no}`}>
      {url ? <img src={url} alt={`${vehicle.make} ${vehicle.model}`} className="h-full w-full object-cover" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center text-muted-foreground"><Car className="h-1/3 w-1/3" /></div>}
      {editable && (
        <>
          <input ref={ref} type="file" accept="image/*" className="hidden" data-testid="vehicle-image-input" onChange={onFile} />
          <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid="change-vehicle-image-btn" className="absolute left-2 top-2 flex h-8 items-center gap-1 rounded-full bg-card/90 px-2.5 text-xs font-medium text-primary backdrop-blur hover:bg-card"><Camera className="h-3.5 w-3.5" />{busy ? "Uploading…" : url ? "Change" : "Add photo"}</button>
        </>
      )}
    </div>
  );
}
